import { render, staticRenderFns } from "./Together.vue?vue&type=template&id=4a393ff0&"
import script from "./Together.vue?vue&type=script&lang=js&"
export * from "./Together.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports